import { signal, effect } from "@angular/core";

import { getStorage } from "./get-storage.function";
import { debounce } from "./debounce.function";

export function storageRoot<T>(
    key: string,
    fallback: T,
    type: 'local' | 'session',
    debounceMs: number,
    ttl?: number
) {
    const __storage = getStorage(type);

    const __oldValueStored =
        __storage instanceof Map
            ? __storage.get(key)
            : __storage.getItem(key);

    let __rootValue = fallback;

    if (__oldValueStored) {
        try {
            const __parsed = JSON.parse(__oldValueStored);

            if (!__parsed.expires || __parsed.expires > Date.now()) {
                __rootValue = __parsed.value;
            }
        } catch {}
    }

    const __rootValue$$ = signal<T>(__rootValue);

    // 👉 expose write functie i.p.v. effect
    const write = debounce((value: T) => {
        const data = {
            value,
            expires: ttl ? Date.now() + ttl : undefined
        };

        const json = JSON.stringify(data);

        if (__storage instanceof Map) {
            __storage.set(key, json);
        } else {
            __storage.setItem(key, json);
        }
    }, debounceMs);

    return { rootValue$$: __rootValue$$, write };
}